import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class CodigoConfeccionImportacionViewModel {
    constructor() {}

    public Id: number;
    public RegistroSanitario: string;
    public RazonSocial: string;
    public Direccion: string;
    public IdMunicipio: number;
    public Municipio: string;
    public IdProvincia: number;
    public Provincia: string;
    public IdCa: number;
    public Ca: string;
    public Activo: boolean;
}

export class CodigoConfeccionImportacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: CodigoConfeccionImportacionItemViewModel[];
}

export class CodigoConfeccionImportacionItemViewModel {
    public Id: number;
    public RegistroSanitario: string;
    public RazonSocial: string;
    public Direccion: string;
    public IdMunicipio: number;
    public Municipio: string;
    public IdProvincia: number;
    public Provincia: string;
    public IdCa: number;
    public Ca: string;
    public Activo: boolean;
}

export class FilterSearchingCodigoConfeccionImportacionViewModel extends FilterSearchingBaseViewModel {
    public RegistroSanitario: string;
    public RazonSocial: string;
    //public Direccion: string;
    //public IdMunicipio: number;
    //public IdMunicipioDescripcion: string;
    //public IdProvincia: number;
    //public IdProvinciaDescripcion: string;
    //public IdCa: number;
    //public IdCaDescripcion: string;
    public Activo: number = EnumSiNoTodos.TODOS;
}
